import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

type ShiftPatternFiltersProps = {
	shiftPatterns: { id: number; name: string }[];
};

const ShiftPatternFilters = ({ shiftPatterns }: ShiftPatternFiltersProps) => {
	const { t } = useTranslation();
	const [shiftPatternExpand, setShiftPatternExpand] = React.useState<boolean>(false);

	if (!shiftPatterns || shiftPatterns.length === 0) return null;
	return (
		<Box display='flex' flexWrap='wrap' mb={1} alignItems='center'>
			<Typography
				sx={{
					fontWeight: 400,
					fontSize: 14,
					fontFamily: "Roboto",
					color: "#000000",
					marginRight: 1,
				}}
			>
				{t("scheduler_shift-patterns")} -
			</Typography>
			{shiftPatterns.length > 0 ? (
				shiftPatterns
					.slice(0, shiftPatternExpand ? undefined : 5)
					.map((pattern: { name: string; id: number }, index: number) => (
						<Box key={pattern.id} mr={0.8}>
							<Typography
								sx={{
									fontWeight: 400,
									fontSize: 14,
									fontFamily: "Roboto",
									color: "#000000",
								}}
							>
								{pattern.name}{index === shiftPatterns.length - 1 ? "" : ","}
							</Typography>
						</Box>
					))
			) : (
				<></>
			)}
			{shiftPatterns.length > 5 ? (
				<Button
					onClick={(e) => setShiftPatternExpand(!shiftPatternExpand)}
					size='small'
				>
					{shiftPatternExpand ? t("scheduler_show-less") : t("scheduler_show-more")}
				</Button>
			) : null}
		</Box>
	);
};

export default ShiftPatternFilters;
